import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-company-workspace',
  imports: [RouterOutlet],
  template: '<router-outlet />',
})
export class CompanyWorkspace {
}
